import React from "react";

const PageHeaderChecklistHandler = () => {
  return (
    <button className="page-header__user-checklist">
      <svg
        width="64px"
        height="64px"
        viewBox="0 -0.5 21 21"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        fill="#000000"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth={0} />
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g id="SVGRepo_iconCarrier">
          <g
            id="Page-1"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="Dribbble-Light-Preview"
              transform="translate(-259.000000, -520.000000)"
              fill="#9191A5"
            >
              <g id="icons" transform="translate(56.000000, 160.000000)">
                <path
                  d="M213.2669,374.512 C213.2669,375.064 212.7965,375.512 212.2169,375.512 C211.6373,375.512 211.1669,375.064 211.1669,374.512 C211.1669,373.96 211.6373,373.512 212.2169,373.512 C212.7965,373.512 213.2669,373.96 213.2669,374.512 M209.0669,365 C209.0669,364.448 209.5373,364 210.1169,364 L216.1124,364 C216.98915,364 217.7,364.677 217.7,365.512 L217.7,368 C217.7,369.1 216.755,370 215.6,370 L214.03445,370 C213.7394,370 213.5,370.228 213.5,370.509 L213.5,371.512 C213.5,372.064 213.03065,372.512 212.45,372.512 C211.8704,372.512 211.4,372.064 211.4,371.512 L211.4,369.778 C211.4,368.796 212.2358,368 213.2669,368 L214.3169,368 C214.8965,368 215.3669,367.552 215.3669,367 C215.3669,366.448 214.8965,366 214.3169,366 L210.1169,366 C209.5373,366 209.0669,365.552 209.0669,365 M220.85,378 L206.15,378 C205.5704,378 205.1,377.552 205.1,377 L205.1,363 C205.1,362.448 205.5704,362 206.15,362 L220.85,362 C221.43065,362 221.9,362.448 221.9,363 L221.9,377 C221.9,377.552 221.43065,378 220.85,378 M203,362 L203,378 C203,379.105 203.9408,380 205.1,380 L221.9,380 C223.06025,380 224,379.105 224,378 L224,362 C224,360.896 223.06025,360 221.9,360 L205.1,360 C203.9408,360 203,360.896 203,362"
                  id="question-[#9191A5]"
                >
                </path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </button>
  );
};

export default PageHeaderChecklistHandler;
